import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { useForm } from "react-hook-form";
import { Tooltip } from "@mui/material";
// import OPDMedicationModal from "./MedicationModal";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import {
  DeleteIcon,
  EditIcon,
  PastHistoryMedication,
} from "./EmrCommonAsset/Asset";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import PastMedication from "./PastMedication";
import { deleteMedication } from "../services/EMRServices/emrServices";
import MedicationModal from "./MedicationModal";
import { format } from "date-fns";
import { successAlert } from "../../../common/components/Toasts/CustomToasts";
export default function Medication(props) {
  const {
    medicationData,
    setMedicationData,
    dataMedication,
    setDataMedication,
    openMedicationModal,
    setOpenMedicationModal,
    actions,
    setActions,
    patientHistoryData,
    setPatientHistoryData,
    weight,
    height,
  } = props;

  const [allMedicationChipsList, setAllMedicationChipsList] = useState([]);
  const [medicationChipsList, setMedicationChipsList] = useState([]);

  const [selectedMedication, setSelectedMedication] = useState(null);

  const [chipsCount, setChipsCount] = useState(5);
  const [checkDuplicate, setCheckDuplicate] = useState(false);
  const [selectedChips, setSelectedChips] = useState([]);
  // const [openMedicationModal, setOpenMedicationModal] = useState(false);
  const [data, setData] = useState([]);
  const [edit, setEdit] = useState(false);
  const [row, setRow] = useState();
  const [index, setIndex] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [save, setSave] = useState(false);
  const [openPastMedication, setOpenPastMedicationModal] = useState(false);
  const [drugTaperingData, setDrugTaperingData] = useState([]);
  const { control } = useForm();

  const handleCloseChild = () => {};

  useEffect(() => {
    if (save === true) {
      setMedicationData([...dataMedication, ...drugTaperingData]);
      setSave(false);
    }
  }, [save]);
  function deleteRow(index) {
    const newComplaintsData = [...medicationData];
    newComplaintsData.splice(index, 1);
    setMedicationData(newComplaintsData);
    setDataMedication(newComplaintsData);
  }
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-2">
        <Tooltip title="Edit">
          <button
            type="button"
            onClick={() => {
              // setEditOpen(true);
              setOpenMedicationModal(true);
              setEdit(true);
              setRow(row);
              setIndex(index);
            }}
          >
            <EditIcon />
          </button>
        </Tooltip>

        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
              if (row?.id !== null && row?.id !== undefined) {
                deleteMedication(row.id)
                  .then((response) => response.data)
                  .then((res) => {
                    if (res.data.statusCode === 200) {
                      successAlert(res.message);
                    }
                    handleCloseChild();
                  })
                  .catch((error) => {
                    // errdeleteAlert(res.message);
                  });
              }
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };

  const mergeArray = (arr) => {
    console.log("item555", arr);

    return arr.reduce((acc, val) => {
      const ind = acc.findIndex((item) => item.drugName === val.drugName);
      if (ind !== -1) {
        console.log("instruction Already Exists");
      } else {
        acc.push(val);
      }
      return acc;
    }, []);
  };

  return (
    <div>
      <div className="flex  bg-[#E7D2FF] rounded-t-md">
        <p className="text-sm font-semibold pl-2 py-2">Medication</p>
        <div className="flex my-auto">
          <button
            type="button"
            onClick={() => {
              setOpenMedicationModal(true);
              setSave(false);
            }}
          >
            <div className="flex justify-between border w-48 mx-2 bg-white rounded-md">
              <p className="text-xs my-auto px-2">Medication</p>
              <SearchIcon />
            </div>
          </button>
          {/* {props.from === "template" ? ("") : (<PastHistoryMedication />)} */}
        </div>
      </div>
      <div className=" border min-h-24 max-h-44  overflow-auto border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
        {/* my-2 max-h-[12rem] overflow-scroll scrollbar-thin  scrollbar-thumb-blue-200 scrollbar-track-blue-50 */}

        {medicationData?.length > 0 ? (
          <div className="">
            <CommonTransactionTable
              dataResult={mergeArray(medicationData).map((row) => ({
                "Drug Type": row.drugType,
                "Drug Name": row.drugName,
                Frequency: row.frequency,
                Dosage: row.dosage,
                Instructions: row.instruction,
                Duration:
                  row.duration +
                  " " +
                  (row.durationIn !== undefined ? row.durationIn : ""),
                Durations: row.duration,
                DurationIn: row.durationIn !== undefined ? row.durationIn : "",
                Quantity: row.quantity,
                Note: row.note,
                Route: row?.route,
                StartDate: row.startDate,
                // IvFlowRate: row?.ivFlowRate,
                id: row?.id,
                drugId: row.drugId,
                code: row.code,
                genericdescription: row.genericdescription,
                drugTapering: row.drugTapering,
                isParent: row.isParent,
              }))}
              renderActions={renderActions}
              // renderInput={renderInput}

              rowBackgroundColor={(row, index) => {
                if (row?.drugTapering === true) {
                  return "#FFDBEF";
                } else if (row?.drugTapering === true) {
                  return "#ffffff";
                }
              }}
              highlightRow={false}
              removeHeaders={[
                "id",
                "code",
                "drugId",
                "code",
                "genericdescription",
                "DurationIn",
                "Durations",
                "drugTapering",
                "Drug Type",
                "isParent",
              ]}
            />
          </div>
        ) : null}

        <div className="">
          <MedicationModal
            actions={actions}
            setActions={setActions}
            medicationData={medicationData}
            setMedicationData={setMedicationData}
            dataMedication={dataMedication}
            setDataMedication={setDataMedication}
            openMedicationModal={openMedicationModal}
            setOpenMedicationModal={setOpenMedicationModal}
            allMedicationChipsList={allMedicationChipsList}
            selectedMedication={selectedMedication}
            // selectedAllergieDecription={selectedAllergieDecription}
            setSelectedChips={setSelectedChips}
            selectedChips={selectedChips}
            data={data}
            setData={setData}
            setEditOpen={setEditOpen}
            edit={edit}
            setEdit={setEdit}
            row={row}
            index={index}
            setSave={setSave}
            patientData={props.patientData}
            weight={weight}
            height={height}
            from={props.from}
            drugTaperingData={drugTaperingData}
            setDrugTaperingData={setDrugTaperingData}
          />
        </div>
        <PastMedication
          patientHistoryData={patientHistoryData}
          setPatientHistoryData={setPatientHistoryData}
          openPastMedication={openPastMedication}
          setOpenPastMedicationModal={setOpenPastMedicationModal}
        />
      </div>
    </div>
  );
}
